import { ApiResponse, getFromServer, postToServer } from "server";
import { RegisterTimingInput } from "../InputsTypes";
import { RegisterTimingOutput, TimingStatisticsOutput } from "../OutputsTypes";

// Route : POST /statistics/timing/register
export const registerTiming = async (
  input: RegisterTimingInput,
): Promise<ApiResponse<RegisterTimingOutput>> => {
  return await postToServer<RegisterTimingInput, RegisterTimingOutput>(
    "/statistics/timing/register",
    input,
  );
};

// Route : GET /statistics/timing
export const getTimingStatistics = async (): Promise<
  ApiResponse<TimingStatisticsOutput>
> => {
  return await getFromServer<TimingStatisticsOutput>("/statistics/timing");
};
